import { render } from "./KycSuccess.vue?vue&type=template&id=978017b8&ts=true"
import script from "./KycSuccess.vue?vue&type=script&lang=ts"
export * from "./KycSuccess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__